<template>
  <div class="view your" data-name="your">
    <RailsContent :data="instagram" :is-medium="false" />
    <PageHero :title="'Your.'" :text="''" />
  </div>
</template>

<script>
import PageHero from '@/components/heros/PageHero.vue';
import RailsContent from '@/components/contents/RailsContent.vue';
import demetra from '../scripts/demetra';

export default {
  name: 'your',

  components: {
    PageHero,
    RailsContent,
  },

  data() {
    return {
      instagram: [],
    };
  },

  mounted() {
    demetra.ref.fetchArchive('instagram').then((response) => {
      response.archive.items.forEach((i) => {
        this.instagram.push(i.structure);
      });
    });
  },
};
</script>
